import react, { useEffect, useState } from "react";
import style from "./style.module.css";
import { useNavigate } from "react-router-dom";

const OwnerInOut = (props) => {
  const [dataInventoryGym1, setDataInventoryGym1] = useState([]);
  const [dataInventoryGym2, setDataInventoryGym2] = useState([]);
  const [namaBarangInput, setNamaBarangInput] = useState("");
  const [hargaInput, setHargaInput] = useState("");
  const [quantityInput, setQuantityInput] = useState("");
  const [keteranganKirim, setKeteranganKirim] = useState("");
  const [lokasiInput, setLokasiInput] = useState("");
  const [penanda, setPenanda] = useState("new");
  const [valueSelect,setValueSelect]=useState("outcome");

  const url = props.url;
  const navigate = useNavigate("");
  // fucntion get data inventory gym 1
  const GetDataInventoryGym = async () => {
    await fetch(url + "/?op=getDataInventoryGym")
      .then((response) => response.json())
      .then((json) => {

        if (json !== null) {
          setDataInventoryGym1(json);
        } else {
                     setDataInventoryGym1([]);
        }
      });
  };
  // fucntion get data inventory gym
  const GetDataInventoryGym2 = async () => {
    await fetch(url + "/?op=getDataInventoryGym2")
      .then((response) => response.json())
      .then((json) => {
        if (json !== null) {
          setDataInventoryGym2(json);
        } else {
                      setDataInventoryGym2([]);
        }
      });
  };
  // fucntion kirim
  const Kirim = () => {
    if (
      namaBarangInput === "" ||
      hargaInput === "" ||
      quantityInput === "" ||
      lokasiInput === ""
    ) {
      setKeteranganKirim("Data tidak lengkap");
    } else {
        let urlKirim;
      if (lokasiInput === "1") {
        urlKirim="inputCashFlowInventoryGym";
        }else if(lokasiInput === "2"){
        urlKirim="inputCashFlowInventoryGym2";
        }
  fetch(url + "/?op="+urlKirim, {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "harga_barang=" +
        hargaInput +
        "&nama_barang=" +
        namaBarangInput+
        "&quantity_barang="+
        quantityInput+
        "&keterangan="+
        valueSelect

  }).then((response)=>response.json())
  .then((json)=>{
   if(json==="berhasil"){
    GetDataInventoryGym();
    GetDataInventoryGym2();
    setNamaBarangInput("");
    setHargaInput("");
    setQuantityInput("");
    setLokasiInput("");
    setPenanda("new");
    setValueSelect("outcome");
    setKeteranganKirim("Berhasil Terkirim");
      setTimeout(() => {
    setKeteranganKirim("");

  }, 1000);
   }
  })
      
     
    }
  };
  // use effectr
  useEffect(() => {
    GetDataInventoryGym();
    GetDataInventoryGym2();
  }, []);
   // use effect cek session
        useEffect(()=>{
                fetch(url + "/?op=cekSession", {
                    credentials: "include", 
                  })
                  .then((response)=>response.json())
                  .then((json)=>{
                   
                  if (json === "kosong") {
                        navigate("/", { replace: true });
                      }else if(json ==="gym2"){
            navigate("/gym2", { replace: true });
                      }else if(json ==="gym1"){
            navigate("/gym1", { replace: true });
                      }
                  })
                },[])
  return (
    <div className={style.containerAll}>
      <div className={style.divKiri}>
        <div className={style.divJudul}>Pricing Inventory Gym 1</div>
        <div className={style.divIsi}>
          <table className={style.tabel}>
            <thead>
              <tr>
                <th>Nama Barang</th>
                <th>Harga Barang</th>
                <th>Quantity Barang</th>
              </tr>
            </thead>
            <tbody>
              {dataInventoryGym1.map((item, index) => (
                <tr
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setNamaBarangInput(item.name);
                    setHargaInput(item.price);
                    setQuantityInput(item.stock);
                    setLokasiInput("1");
                      setPenanda("");
                  }}
                  key={index}
                >
                  <td>{item.name}</td>
                  <td>{item.price}</td>
                  <td>{item.stock}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className={style.divKanan}>
        <div className={style.divJudul}>Pricing Inventory Gym 2</div>
        <div className={style.divIsi}>
          <table className={style.tabel}>
            <thead>
              <tr>
                <th>Nama Barang</th>
                <th>Harga Barang</th>
                <th>Quantity Barang</th>
              </tr>
            </thead>
            <tbody>
              {dataInventoryGym2.map((item, index) => (
                <tr
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setNamaBarangInput(item.name);
                    setHargaInput(item.price);
                    setQuantityInput(item.stock);
                    setLokasiInput("2");
                    setPenanda("");
                  }}
                  key={index}
                >
                  <td>{item.name}</td>
                  <td>{item.price}</td>
                  <td>{item.stock}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className={style.divInput}>
        <div
          onClick={() => {
            setPenanda("new");
            setNamaBarangInput("");
            setHargaInput("");
            setQuantityInput("");
            setLokasiInput("");
          }}
          style={{ backgroundColor: penanda === "new" ? "green" : "grey" }}
          className={style.divNew}
        >
          New
        </div>
        <div className={style.divJudulInput}>Input</div>
        <input  onChange={(e)=>setNamaBarangInput(e.target.value)} placeholder="Nama Barang" value={namaBarangInput} />
        <input  onChange={(e)=>setHargaInput(e.target.value)} placeholder="Harga Beli Barang Total" value={hargaInput} />
        <input
          type="number"
          placeholder="Quantity Total"
          value={quantityInput}
          onChange={(e)=>setQuantityInput(e.target.value)}
        />
        <input onChange={(e)=>setLokasiInput(e.target.value)} placeholder="Lokasi tulis angka 1 atau 2" value={lokasiInput} />
        <select value={valueSelect} className={style.select} onChange={(e)=>setValueSelect(e.target.value)}>
            <option value="outcome">
                outcome
            </option>
             <option value="income">
                income
            </option>
        </select>
        <div
          style={{
            color: keteranganKirim === "Data tidak lengkap" ? "red" : "black",
          }}
          className={style.keteranganKirim}
        >
          {keteranganKirim}
        </div>
        <button onClick={() => Kirim()}>Kirim</button>
      </div>
    </div>
  );
};
export default OwnerInOut;
